"use client";

import { useSearchParams } from "next/navigation";

import { AuthModeSwitch } from "@/components/auth/auth-mode-switch";
import { formMode } from "@/components/auth/form-mode";
import LoginForm from "@/components/auth/login-form.container";
import { AUTH_AUDIENCES } from "@/lib/constants/auth-audiences";
import { parseEmail } from "@/lib/schemas/email";

type SearchParamsLike = {
  get: (key: string) => string | null;
} | null;

export function getSourceEmail(
  searchParams: SearchParamsLike,
): string | undefined {
  return parseEmail(searchParams?.get("source_email") ?? null);
}

export function AuthFormWrapper({
  formMode: mode,
  onSuccess,
}: {
  formMode: formMode;
  onSuccess?: () => void;
}): React.JSX.Element {
  const searchParams = useSearchParams();
  const defaultEmail = getSourceEmail(searchParams);

  return (
    <LoginForm
      mode={mode}
      audience={AUTH_AUDIENCES.JOB_SEEKER}
      defaultEmail={defaultEmail}
      onSuccess={onSuccess}
      footer={<AuthModeSwitch mode={mode} query={searchParams.toString()} />}
    />
  );
}
